export const subscriptionDetailsData = {
  th: ["ITEM", "NO. OF UNITS", "TOTAL/MONTH"],
  td: [
    { item: "Professional Plan", units: "300", amount: "₹ 36,000.00" },
    { item: "Professional Plan", units: "300", amount: "₹ 36,000.00" },
    { item: "", units: "NET TOTAL", amount: "₹ 4,00,000.00" },
  ],
};

export const transactionHistoryData = {
  th: [
    "Transaction ID",
    "Type",
    "Product",
    "Plan Name",
    "Date",
    "Amount",
    "Invoice",
  ],
  td: [
    {
      id: "277000150834355",
      type: "Upgrade",
      product: "People",
      plan: "Professional",
      date: "17 Sep 2022",
      amount: "₹4,248*",
      invoice: "Invoice",
    },
    {
      id: "277000150834355",
      type: "Upgrade",
      product: "People",
      plan: "Professional",
      date: "17 Sep 2022",
      amount: "₹4,248*",
      invoice: "Invoice",
    },
    {
      id: "277000150834355",
      type: "Upgrade",
      product: "People",
      plan: "Professional",
      date: "17 Sep 2022",
      amount: "₹4,248*",
      invoice: "Invoice",
    },
    {
      id: "277000150834355",
      type: "Upgrade",
      product: "People",
      plan: "Professional",
      date: "17 Sep 2022",
      amount: "₹4,248*",
      invoice: "Invoice",
    },
    {
      id: "277000150834355",
      type: "Upgrade",
      product: "People",
      plan: "Professional",
      date: "17 Sep 2022",
      amount: "₹4,248*",
      invoice: "Invoice",
    },
    {
      id: "277000150834355",
      type: "Upgrade",
      product: "People",
      plan: "Professional",
      date: "17 Sep 2022",
      amount: "₹4,248*",
      invoice: "Invoice",
    },
    {
      id: "277000150834355",
      type: "Upgrade",
      product: "People",
      plan: "Professional",
      date: "17 Sep 2022",
      amount: "₹4,248*",
      invoice: "Invoice",
    },
    {
      id: "277000150834355",
      type: "Upgrade",
      product: "People",
      plan: "Professional",
      date: "17 Sep 2022",
      amount: "₹4,248*",
      invoice: "Invoice",
    },
  ],
};

export const upgradeUsersData = {
  th: ["ITEM", "NO. OF UNITS", "TOTAL/MONTH"],
  td: [
    { item: "Professional Plan", units: "300", amount: "₹ 36,000.00" },
  ],
};


export const ReadProSubscriptionDetails ={
  email: "rishisharmazee@gmail.com",
  oid: "242239",
  licences: "37",
  MarketingPlans: [
    {
      title: "Whatsapp",
      totalBalance: "80,000",
      list:[
        {
          label: "Whatsapp_60000",
          date: "12/03/2024",
          amount: "400",
        },
        {
          label: "Whatsapp_60000",
          date: "12/03/2024",
          amount: "400",
        },
        {
          label: "Whatsapp_60000",
          date: "12/03/2024",
          amount: "400",
        },
      ],
      splTxt: "1 pack expiring in 7 days",
    },
    {
      title: "E Mail",
      totalBalance: "80,000",
      list:[
        {
          label: "Mail_60000",
          date: "12/03/2024",
          amount: "400",
        },
        {
          label: "Balance_Topup",
          date: "12/03/2024",
          amount: "400",
        },
      ],
    },
    {
      title: "SMS",
      totalBalance: "80,000",
      list:[
        {
          label: "SMS_500",
          date: "12/03/2024",
          amount: "400",
        },
        {
          label: "Whatsapp_300",
          date: "12/03/2024",
          amount: "400",
        },
        {
          label: "Balance_Topup",
          date: "12/03/2024",
          amount: "400",
        },
      ],
      splTxt: "Offers available",
    },
  ]
}

// export const whatsappRechangePlans = [
//   {
//     isPopular: true,
//     isBestValue: false,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "365 days",
//     balance: "50000",
//   },
//   {
//     isPopular: true,
//     isBestValue: false,
//     isTopup: true,
//     discountedValue: null,
//     originalValue: "60000",
//     discountPercent: null,
//     validity: "Active Plan",
//     balance: "100000",
//   },
//   {
//     isPopular: false,
//     isBestValue: true,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "45 Days",
//     balance: "50000",
//   },
//   {
//     isPopular: false,
//     isBestValue: false,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "365 Days",
//     balance: "50000",
//   },
//   {
//     isPopular: false,
//     isBestValue: true,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "45 Days",
//     balance: "50000",
//   },
//   {
//     isPopular: false,
//     isBestValue: false,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "365 Days",
//     balance: "50000",
//   },
//   {
//     isPopular: false,
//     isBestValue: true,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "45 Days",
//     balance: "50000",
//   },
//   {
//     isPopular: false,
//     isBestValue: false,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "365 Days",
//     balance: "50000",
//   },
//   {
//     isPopular: false,
//     isBestValue: true,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "45 Days",
//     balance: "50000",
//   },
//   {
//     isPopular: false,
//     isBestValue: false,
//     isTopup: false,
//     discountedValue: "42000",
//     originalValue: "60000",
//     discountPercent: "30",
//     validity: "365 Days",
//     balance: "50000",
//   },
// ]

export const whatsappRechangePlans = [
  {
    id:"1",
    isPopular: true,
    isBestValue: false,
    isTopup: false,
    discountedValue: "42000",
    originalValue: "60000",
    discountPercent: "30",
    validity: "365 days",
    balance: "50000",
    packageId:"310947",
  },
  {
    id:"2",
    isPopular: true,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "55000",
    discountPercent: null,
    validity: "Active Plan",
    balance: "100000",
    packageId:"310947",
  },
  {
    id:"3",
    isPopular: false,
    isBestValue: true,
    isTopup: false,
    discountedValue: "35000",
    originalValue: "50000",
    discountPercent: "30",
    validity: "45 Days",
    balance: "50000",
    packageId:"310947",
  },
  {
    id:"4",
    isPopular: false,
    isBestValue: false,
    isTopup: false,
    discountedValue: "30000",
    originalValue: "40000",
    discountPercent: "25",
    validity: "365 Days",
    balance: "50000",
    packageId:"310947",
  },
  {
    id:"5",
    isPopular: false,
    isBestValue: true,
    isTopup: false,
    discountedValue: "20000",
    originalValue: "30000",
    discountPercent: "33",
    validity: "45 Days",
    balance: "50000",
    packageId:"310947",
  },
  {
    id:"6",
    isPopular: false,
    isBestValue: false,
    isTopup: false,
    discountedValue: "18000",
    originalValue: "25000",
    discountPercent: "28",
    validity: "365 Days",
    balance: "50000",
    packageId:"310947",
  },
  {
    id:"7",
    isPopular: false,
    isBestValue: true,
    isTopup: false,
    discountedValue: "12000",
    originalValue: "20000",
    discountPercent: "40",
    validity: "45 Days",
    balance: "50000",
    packageId:"310947",
  },
  {
    id:"8",
    isPopular: false,
    isBestValue: false,
    isTopup: false,
    discountedValue: "15000",
    originalValue: "22000",
    discountPercent: "32",
    validity: "365 Days",
    balance: "50000",
    packageId:"310947",
  },
  {
    id:"9",
    isPopular: false,
    isBestValue: true,
    isTopup: false,
    discountedValue: "5000",
    originalValue: "10000",
    discountPercent: "50",
    validity: "45 Days",
    balance: "50000",
    packageId:"310947",
  },
  {
    id:"10",
    isPopular: false,
    isBestValue: false,
    isTopup: false,
    discountedValue: "9000",
    originalValue: "12000",
    discountPercent: "25",
    validity: "365 Days",
    balance: "50000",
    packageId:"310947",
  },
];


export const emailRechangePlans = [
  {
    isPopular: false,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "60000",
    discountPercent: null,
    validity: "Active Plan",
    balance: "100000",
  },
  {
    isPopular: false,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "60000",
    discountPercent: null,
    validity: "45 Days",
    balance: "50000",
  },
  {
    isPopular: false,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "60000",
    discountPercent: null,
    validity: "Active Plan",
    balance: "100000",
  },
  {
    isPopular: false,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "60000",
    discountPercent: null,
    validity: "45 Days",
    balance: "50000",
  },
  {
    isPopular: false,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "60000",
    discountPercent: null,
    validity: "Active Plan",
    balance: "100000",
  },
  {
    isPopular: false,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "60000",
    discountPercent: null,
    validity: "45 Days",
    balance: "50000",
  },
  {
    isPopular: false,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "60000",
    discountPercent: null,
    validity: "Active Plan",
    balance: "100000",
  },
  {
    isPopular: false,
    isBestValue: false,
    isTopup: true,
    discountedValue: null,
    originalValue: "60000",
    discountPercent: null,
    validity: "45 Days",
    balance: "50000",
  },
]

export const whatsappSetupDispositionTabs = [
  {
    id: "Call Back",
    title: "Call Back",
  },
  {
    id: "Interested",
    title: "Interested",
  },
  {
    id: "Not Interested",
    title: "Not Interested",
  },
  {
    id: "Won",
    title: "Won",
  },
  {
    id: "Lost",
    title: "Lost",
  }
]

export const whatsappSetupTempTabs = [
  {
    id: "Call Back",
    title: "Call Back",
  },
  {
    id: "Interested",
    title: "Interested",
  },
  {
    id: "Not Interested",
    title: "Not Interested",
  },
  {
    id: "Won",
    title: "Won",
  },
  {
    id: "Lost",
    title: "Lost",
  }
]

export const whatsappSetupMakretingTabs = [
  {
    id: "Pre Launch",
    title: "Pre Launch",
  },
  {
    id: "Offers",
    title: "Offers",
  },
  {
    id: "Genric",
    title: "Genric",
  },
  {
    id: "My Templates",
    title: "My Templates",
  },
]